/* eslint-env browser, es6 */
import m from "mithril";

import * as api from "./api";
import * as urls from "./urls";

import { ApiError, Duel } from "./api";
import { GameView } from "./components/game";
import { GAME, GameStateMarker } from "./game-state";
import { generateRandomBoard } from "./board";

const CSS_ROOT_SELECTOR = ".game";

interface RouteParams {
  duelId: string;
}

function initPendingDuelPage(routeParams: RouteParams) {
  GAME.state = {
    marker: GameStateMarker.Loading,
  };

  const duelId = routeParams.duelId;
  api
    .getActiveDuel(duelId)
    .then((duel: Duel | null) => {
      if (duel) {
        GAME.state = {
          marker: GameStateMarker.DuelChallenge1,
          duel,
        };
      } else {
        urls.setHomeUrl();
        GAME.state = {
          marker: GameStateMarker.NotStarted,
          board: generateRandomBoard(),
          startingDuel: false,
          duelNotFound: true,
        };
      }
    })
    .catch((error: ApiError) => {
      GAME.state = {
        marker: GameStateMarker.NotStarted,
        board: generateRandomBoard(),
        startingDuel: false,
        duelNotFound: false,
        error,
      };
    });
}

function initDuelResultsPage(routeParams: RouteParams) {
  GAME.state = {
    marker: GameStateMarker.Loading,
  };

  const duelId = routeParams.duelId;
  api
    .getDuel(duelId)
    .then((duel: Duel | null) => {
      if (duel) {
        GAME.state = {
          marker: GameStateMarker.DuelResults,
          duel,
        };
      } else {
        urls.setHomeUrl();
        GAME.state = {
          marker: GameStateMarker.NotStarted,
          board: generateRandomBoard(),
          startingDuel: false,
          duelNotFound: true,
        };
      }
    })
    .catch((error: ApiError) => {
      GAME.state = {
        marker: GameStateMarker.NotStarted,
        board: generateRandomBoard(),
        startingDuel: false,
        duelNotFound: false,
        error: {
          message: "could not load duel",
          code: error.code,
        },
      };
    });
}

function main() {
  const rootElement = document.querySelector(CSS_ROOT_SELECTOR);
  if (!rootElement) {
    throw new Error(`element not found for CSS selector: ${CSS_ROOT_SELECTOR}`);
  }

  m.route.prefix = "";
  m.route(rootElement, "/webble", {
    "/webble": GameView,
    "/webble/p/:duelId": {
      onmatch: initPendingDuelPage,
      render() {
        return m(GameView);
      },
    },
    "/webble/r/:duelId": {
      onmatch: initDuelResultsPage,
      render() {
        return m(GameView);
      },
    },
  });
}

main();
